import './App.css'
import { BrowserRouter, Redirect, Route, Switch, useHistory } from 'react-router-dom'
import Vault from './pages/Vault'
import SignIn from './pages/SignIn'
import EmailConfirmation from './pages/EmailConfirmation'
import MyProfile from './pages/MyProfile'

import { setCurrentArtist } from 'redux/actions/artistActions'
import Pricing from './pages/Pricing'

import { createTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import ConfirmEmailAddress from 'pages/ConfirmEmailAddress'
import Contact from 'pages/Contact'
import Privacy from 'pages/Privacy'
import TermsOfService from 'pages/TermsOfService'
import firebase from 'firebase/compat/app'
import Settings from 'pages/Settings'
import { useEffect } from 'react'
import ManageApprovals from 'pages/admin/ManageApprovals'
import { getFirebaseConfig } from 'util/firebaseUtils'
import Credits from 'pages/Credits'
import FAQ from 'pages/help/FAQ'
import { getStorageAccount } from 'redux/actions/accountActions'
import { getStorageSettings } from 'redux/actions/settingsActions'
import { setSettings } from 'redux/actions/settingsActions'
import Introduction from 'pages/vortex/Introduction'
import PaymentResult from 'components/payment/PaymentResult'
import CreateRoom from 'pages/vortex/CreateRoom'
import { EditRoom } from 'components/vortex/EditRoom'
import About from 'pages/About'
import Approvals from 'pages/help/Approvals'
import BuyCredits from 'components/payment/BuyCredits'
import VortexSwitch from 'components/vortex/VortexSwitch'
import EmbedAI from 'pages/vortex/EmbedAI'
import UserProfile from 'pages/UserProfile'
import CreateCollection from 'pages/harmonize/CreateCollection'
import Studios from 'pages/harmonize/Studios'
import { isAdminUser } from 'util/adminUtils'
import { useState } from 'react'
import { Snackbar, SnackbarContent } from '@material-ui/core'
import AboutStudios from 'pages/help/AboutStudios'
import { RESERVED_STUDIO_NAMES } from 'util/postUtils'
import Subscribers from 'pages/harmonize/Subscribers'
import Notifications from 'pages/harmonize/Notifications'
import HarmonizeHome from 'pages/harmonize/HarmonizeHome'
import { setFullscreen } from 'redux/actions/harmonizeActions'
import { setFetchStart } from 'redux/actions/fetchActions'
import { setCategoryMode } from 'redux/actions/fetchActions'
import { CATEGORY_MODES } from 'redux/reducers/harmonizeReducer'
import { setCurrentRoom } from 'redux/actions/messagesActions'
import { setCurrentRoomOwner } from 'redux/actions/messagesActions'
import { setUserStartedPlayback } from 'redux/actions/playerControlActions'
import { useSelector } from 'react-redux'
import CreatePost from 'pages/harmonize/CreatePost'
import { setVideoPlaying } from 'redux/actions/playerControlActions'
import { setCurrentCollection } from 'redux/actions/harmonizeActions'
import { setEndOfMessages } from 'redux/actions/messagesActions'
import { initializeAnalytics } from 'util/analyticsUtil'
import { isGooglebot } from 'util/screenUtils'
import GoogleBotPage from 'components/seo/GoogleBotPage'
import { setPlayerMode } from 'redux/actions/harmonizeActions'
import { PLAYER_MODES } from 'redux/reducers/harmonizeReducer'
import MintNFT from 'pages/nft/MintNFT'
import DisplayNFT from 'pages/nft/DisplayNFT'
import PurchaseNFT from 'pages/nft/PurchaseNFT'
import ManageNFT from 'pages/nft/ManageNFT'

//This seemed to fix the Typography references
const theme = createTheme({
  typography: {
    allVariants: {
      color: 'black',
    },
    fontSize: '0.9em',
    lineHeight: '1.5',
    fontFamily: [
      'Raleway',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
})

/* Configure Firebase. It needs to be here so that whatever is created is globally available
without hoops */
firebase.initializeApp(getFirebaseConfig())
initializeAnalytics()

export default function App({ store }) {

  const { signedIn } = useSelector(state => state.account)
  const [notification, setNotification] = useState(null)
  //const { currentRoom } = useSelector(state => state.messages)
  const history = useHistory()

  const isSignedIn = () => {
    return signedIn
  }

  /**
   * All url access to a specific song etc should reference the Studio handle
   * harmonize/@cj
   * harmonize/@cj/[room]
   * harmonize/@cj/song/[songname | messageId]
   * harmonize/@cj/collection/[collectionid]
   * 
   * So that:
   * - song and collection are reserved
   * - The studio can be retrieved before the room connection is made
   * 
   * - [handle] is pathParts[1]
   * - [room], song | collection is pathParts[2]
   * - [songname], [messageId] or [collectionId] is pathParts[3]
   * @returns 
   */
  const processStudio = () => {
    console.log('\n**App Determine artist, room and optional retrieval specifics')
    let handle, roomName, artist
    const pathname = window.location.pathname.toLowerCase()
    //This means the pathname can be of form /@[handle]/[something else]
    let ixEnd = pathname.indexOf('/', 2)
    if (ixEnd === -1) {
      ixEnd = pathname.length
    }
    const userHandleLength = ixEnd - 2
    if (userHandleLength > 0) {
      const pathParts = pathname.split('/')
      handle = pathParts[1].substring(1)
      console.log(`handle ${handle} ${userHandleLength} pathParts`, pathParts)
      let requestedSong, requestedCollection
      if (pathParts.length > 2) {
        //There was a second part
        if (RESERVED_STUDIO_NAMES.includes(pathParts[2])) {
          roomName = pathParts[2]
          console.log(`roomName ${roomName}`)
          switch (roomName) {
            case 'song':
              requestedSong = pathParts[3]
              roomName = 'home'
              break
            case 'collection':
              requestedCollection = pathParts[3]
              roomName = 'home'
              break
            default:
              break
          }

        }
        artist = { handle, selectedRoom: roomName, requestedSong, requestedCollection }
      } else {
        artist = { handle, selectedRoom: 'home' }
      }
      console.log(`**App artist`, artist)
      store.dispatch(setEndOfMessages(false))
      store.dispatch(setCurrentArtist(artist))
      store.dispatch(setUserStartedPlayback(false))
      store.dispatch(setVideoPlaying(false))
      store.dispatch(setCurrentCollection(null))
    }
  }
  /**
   * There is something wrong with redux-persist or how we are using it: in production, when the browser
   * is restarted or navigated to the absolute URL, persistence is gone. When running
   * against localhost, everything works.
   *
   * But in production local storage is preserved, so we use the latter to build redux store.
   * Just be sure the Web server redirects everything to the same subdomain so that you only have
   * one localStorage instance.
   *
   * @returns The component that is rendered for the home screen
   */
  const renderHome = () => {

    const settings = getStorageSettings()
    if (settings) {
      store.dispatch(setSettings(settings))
    }

    const pathname = window.location.pathname.toLowerCase()
    const { currentRoom } = store.getState().messages
    console.log(`renderHome hostname ${window.location.hostname} pathname ${pathname}`, currentRoom)
    if (
      (pathname.startsWith('/@'))
    ) {
      if (isGooglebot(window.navigator.userAgent)) {
        return <GoogleBotPage />
      }
      processStudio()
      return <VortexSwitch />
    } else if (pathname === '/' && currentRoom) {
      console.log('Switching from Studio to Harmonize home, reset categoryMode to ALL ')
      store.dispatch(setCurrentCollection(null))
      store.dispatch(setCurrentRoom(null))
      store.dispatch(setCurrentRoomOwner(null))
      store.dispatch(setCategoryMode(CATEGORY_MODES.RESET))
      store.dispatch(setFetchStart(0))
    }
    /* You need to call this if you want clearing localStorage to actually reset redux. BUT
    it doesn't work reliably so go figure 
    if (process.env.REACT_APP_MODE === 'development') {
      console.log('WARNING: redux purged')
      persistor.purge()
    }
    */
    store.dispatch(setCurrentArtist(null))
    store.dispatch(setFullscreen(false))
    store.dispatch(setUserStartedPlayback(false))
    store.dispatch(setVideoPlaying(false))
    store.dispatch(setPlayerMode(PLAYER_MODES.SWIPE))
    return process.env.REACT_APP_INTRODUCTION === 'true' ? <Introduction /> : <HarmonizeHome />

  }

  const displayNotification = () => {
    if (notification) {
      const { body, title } = notification
      const notifyAccount = getStorageAccount()
      console.log('displayNotification', notifyAccount)
      const { handle } = notifyAccount
      return (

        <Snackbar
          open={notification !== null}
          onClose={() => { setNotification(null) }}
          anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        >
          <SnackbarContent
            style={{ backgroundColor: 'blue', border: '1px solid white' }}
            message={<><div>APP: {title}</div><div>{body}</div></>}
            action={<div style={{ cursor: 'pointer', color: 'gold' }} onClick={() => {
              setNotification(null)
              history.push(`${process.env.REACT_APP_HARMONIZE_HOST}/@${handle}`)
            }}>
              <i>Click to enter your studio</i>
            </div>} />
        </Snackbar>
      )
    }
  }
  const displayApp = () => (

    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <div>
          <Switch>
            <Route exact path='/' render={() => renderHome()} />
            <Route
              exact
              path='/CreatePost/:messageId?'
              render={() => {
                if (isSignedIn()) {
                  return <CreatePost />
                }
                return <SignIn returnPath='CreatePost' />
              }}
            />
            <Route
              exact
              path='/CreateRoom'
              render={() => {
                if (isSignedIn()) {
                  return <CreateRoom />
                }
                return <SignIn returnPath='CreateRoom' />
              }}
            />
            <Route
              exact
              path='/CreateCollection/:messageId'
              render={() => {
                if (isSignedIn()) {
                  return <CreateCollection />
                }
                return <SignIn returnPath='CreateCollection' />
              }}
            />
            <Route
              exact
              path='/EditCollection/:collectionId'
              render={() => {
                if (isSignedIn()) {
                  return <CreateCollection />
                }
                return <SignIn returnPath='CreateCollection' />
              }}
            />

            <Route
              exact
              path='/embed/:roomId'
              component={EmbedAI}
            />
            <Route
              exact
              path='/About'
              component={About}
            />

            {/*
            <Route
              exact
              path='/help/AboutEmbeds'
              component={AboutEmbeds}
            />
            */}
            <Route
              exact
              path='/help/AboutStudios'
              component={AboutStudios}
            />
            <Route
              exact
              path='/help/Approvals'
              component={Approvals}
            />
            <Route
              exact
              path='/Contact/:initialMessage?'
              component={Contact}
            />

            <Route exact path='/Introduction' component={Introduction} />
            <Route exact path='/Pricing' component={Pricing} />
            <Route
              exact
              path='/DisplayNFT/:tokenId'
              render={() => {
                if (isSignedIn()) {
                  return <DisplayNFT />
                }
                return <SignIn returnPath='DisplayNFT' />
              }}
            />
            <Route
              exact
              path='/ManageNFT/:tokenId'
              render={() => {
                if (isSignedIn()) {
                  return <ManageNFT />
                }
                return <SignIn returnPath='ManageNFT' />
              }}
            />            
            <Route
              exact
              path='/MintNFT/:messageId'
              render={() => {
                if (isSignedIn()) {
                  return <MintNFT />
                }
                return <SignIn returnPath='MintNFT' />
              }}
            />
            <Route
              exact
              path='/PurchaseNFT/:tokenId'
              render={() => {
                if (isSignedIn()) {
                  return <PurchaseNFT />
                }
                return <SignIn returnPath='PurchaseNFT' />
              }}
            />            
            <Route exact path='/Privacy' render={() => <Privacy />} />
            <Route exact path='/Credits' render={() => <Credits />} />

            <Route
              exact
              path='/TermsofService'
              render={() => <TermsOfService />}
            />
            <Route
              exact
              path='/EditRoom'
              render={() =>
                isSignedIn() ? <EditRoom /> : <SignIn returnPath='EditRoom' />
              }
            />

            <Route
              exact
              path='/Vault'
              render={() =>
                isSignedIn() ? <Vault /> : <SignIn returnPath='Vault' />
              }
            />

            <Route
              exact
              path='/Settings'
              render={() => (isSignedIn() ? <Settings /> : <SignIn />)}
            />
            <Route
              exact
              path='/SignIn/:returnToHandle?/:returnToRoom?'
              render={() =>
                isSignedIn() ? (
                  <Redirect to='/' />
                ) : (
                  <SignIn />
                )
              }
            />

            <Route
              path='/firebase'
              component={EmailConfirmation}
            />

            <Route
              exact
              path='/ConfirmEmailAddress'
              component={ConfirmEmailAddress}
            />

            <Route
              exact
              path='/MyProfile'
              render={() => (isSignedIn() ? <MyProfile /> : <SignIn />)}
            />

            <Route
              exact
              path='/Notifications'
              render={() => (isSignedIn() ? <Notifications /> : <SignIn returnPath='Notifications' />)}
            />
            <Route
              exact
              path='/Studios'
              render={() => (isSignedIn() ? <Studios /> : <SignIn returnPath='Studios' />)}
            />

            <Route
              exact
              path='/Subscribers'
              render={() => (isSignedIn() ? <Subscribers /> : <SignIn returnPath='Subscribers' />)}
            />

            <Route
              path='/UserProfile/:username'
              component={UserProfile}
            />

            <Route
              exact
              path='/BuyCredits'
              render={() => {
                if (isSignedIn()) {
                  return <BuyCredits />
                }
                return <SignIn returnPath='/BuyCredits' fromBuyCredits />
              }}
            />
            <Route
              exact
              path='/PaymentResult'
              render={() => {
                if (isSignedIn()) {
                  return <PaymentResult />
                }
                return <SignIn returnPath='PaymentResult' />
              }}
            />


            <Route
              exact
              path='/admin/ManageApprovals'
              render={() => {
                if (isAdminUser()) {
                  return <ManageApprovals />
                }
                return <Redirect to='/' />
              }}
            />

            <Route exact path='/help/FAQ' component={FAQ} />
            {/* This route handles 404 errors */}
            <Route component={() => renderHome()} />
          </Switch>
          {displayNotification()}
        </div>
      </ThemeProvider>
    </BrowserRouter>

  )

  useEffect(() => {
    document.title = process.env.REACT_APP_NAME
  }, [])

  return displayApp()
}
